import {websocket} from "../lib";
import {useEffect, useState} from "react";

export const useWebsocket = (event: string, action: (data: any) => void, deps: any[] = []) => {
    useEffect(() => {
        websocket.on(event, action);
        return () => websocket.off(event, action);
    }, deps);
};

export const useWebsocketOnce = (event: string, action: (data: any) => void, deps: any[] = []) => {
    useEffect(() => {
        websocket.once(event, action);
        return () => websocket.offOnce(event, action);
    }, []);
};

export const useWebsocketDataSource = <T>(source: string, key: string = "default", defaultValue = undefined): [T, (next: T) => void] => {
    const eventKey = `datasource.${source}`;
    const [data, setData] = useState<T>(defaultValue);

    useWebsocket(eventKey, ({key: otherKey, value}) => {
        if (otherKey !== key) return;
        setData(value);
    });
    const _setData = (value: T): void => {
        websocket.emit(eventKey, {key, value});
    };

    return [data, _setData];
};
